import { render, staticRenderFns } from "./TemplateDataTabs.vue?vue&type=template&id=2a30214d"
import script from "./TemplateDataTabs.vue?vue&type=script&lang=js"
export * from "./TemplateDataTabs.vue?vue&type=script&lang=js"
import style0 from "./TemplateDataTabs.vue?vue&type=style&index=0&id=2a30214d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports